import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Col } from 'shards-react';

import SidebarMainNavbar from './SidebarMainNavbar';
import SidebarNavItems from './SidebarNavItems';

import { Store } from '../../../flux';

class MainSidebar extends React.Component {
  constructor(props) {
    super(props);

    const { role, idEstablishment } = this.props;

    this.state = {
      role,
      idEstablishment: idEstablishment,
      menuVisible: false,
      sidebarNavItems: Store.getSidebarItems(),
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  componentWillReceiveProps(nextProps) {
    const { role, idEstablishment } = nextProps;
    this.setState({
      ...this.state,
      role,
      idEstablishment,
    });
  }

  onChange() {
    const { role, idEstablishment } = this.props;

    this.setState({
      ...this.state,
      role,
      idEstablishment,
      menuVisible: Store.getMenuState(),
      sidebarNavItems: Store.getSidebarItems(),
    });
  }

  render() {
    const classes = classNames('main-sidebar', 'px-0', 'col-12', this.state.menuVisible && 'open');

    return (
      <Col tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
        <SidebarMainNavbar
          hideLogoText={this.props.hideLogoText}
          role={this.state.role}
          idEstablishment={this.state.idEstablishment}
        />
        <SidebarNavItems role={this.state.role} />
      </Col>
    );
  }
}

MainSidebar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

MainSidebar.defaultProps = {
  hideLogoText: false,
};

export default MainSidebar;
